import { lazy, ComponentType } from 'react';

export interface PartnerRoute {
  path: string;
  component: ComponentType;
}

export interface PartnerConfig {
  partnerId: number;
  routes: PartnerRoute[];
}

const RobibetRootLanding = lazy(() => import('../pages/RootLanding'));
const RobibetSignIn = lazy(() => import('../auth/SignIn'));
const RobibetSignUp = lazy(() => import('../auth/SignUp'));
const RobibetAbout = lazy(() => import('../pages/About'));
const RobibetInstructions = lazy(() => import('../pages/Instructions'));
const RobibetForgotPassword = lazy(() => import('../pages/ForgotPassword'));
const RobibetResetPassword = lazy(() => import('../pages/ResetPassword'));

export const ROBIBET_CONFIG: PartnerConfig = {
  partnerId: 9,
  routes: [
    { path: '/', component: RobibetRootLanding },
    { path: '/about', component: RobibetAbout },
    { path: '/instructions', component: RobibetInstructions },
    { path: '/forgot-password', component: RobibetForgotPassword },
    { path: '/reset-password', component: RobibetResetPassword },
    { path: '/sign-in', component: RobibetSignIn },
    { path: '/sign-up', component: RobibetSignUp },
  ],
};

export const PARTNER_CONFIGS: Record<number, PartnerConfig> = {
  9: ROBIBET_CONFIG,
};

export const getPartnerConfig = (partnerId: number): PartnerConfig | null => {
  return PARTNER_CONFIGS[partnerId] || null;
};

// Helper to get route paths for navigation
export const getPartnerRoutePaths = (
  partnerId: number,
): {
  home: string;
  about: string;
  instructions: string;
  signIn: string;
  signUp: string;
  forgotPassword: string;
  affiliateAgreement: string;
} | null => {
  const config = PARTNER_CONFIGS[partnerId];
  if (!config) return null;

  return {
    home: config.routes.find((r) => r.path === '/')?.path || '/',
    about: config.routes.find((r) => r.path === '/about')?.path || '/about',
    instructions: config.routes.find((r) => r.path === '/instructions')?.path || '/instructions',
    affiliateAgreement: config.routes.find((r) => r.path === '/affiliate-agreement')?.path || '/affiliate-agreement',
    forgotPassword: config.routes.find((r) => r.path === '/forgot-password')?.path || '/forgot-password',
    signIn: config.routes.find((r) => r.path === '/sign-in')?.path || '/sign-in',
    signUp: config.routes.find((r) => r.path === '/sign-up')?.path || '/sign-up',
  };
};
